module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-LightItalic.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-LightItalic.ttf
// module id = 52
// module chunks = 8